import React from 'react'

const ToxicologyTestingProcess = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding6rem right-padding6rem py-md-5 py-4 bg-img' style={{ backgroundImage:'url("https://unitedlabcare.com/wp-content/uploads/2022/12/ULC-Testing-bg-v1.png")'}}>
            <div className='py-1'>
                <text className='fs-ss-30-2 text-montserrat text-ss-primary fw-700 lh-1-2'>
                    The Process of Toxicology Testing
                </text>
                <hr className='hr-style my-md-2' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
            </div>

            <div className='py-2'>
                <text className='fs-ss-16 text-montserrat text-ss-black fw-600' style={{ letterSpacing:'0.5px'}}>
                    The process of toxicology testing involves several steps, including:
                </text>
            </div>

            <div className='py-2'>
                <text className='fs-ss-22 text-ss-secondary text-montserrat fw-700'>
                    Exposure Assessment
                </text>
            </div>

            <div className='py-2 pb-3'>
                <text className='fs-ss-16 text-montserrat text-ss-black fw-600' style={{ letterSpacing:'0.5px'}}>
                    Exposure assessment is the first step in toxicology testing. It involves determining the level and duration of exposure to a substance.
                </text>
            </div>

            <div className='py-2'>
                <text className='fs-ss-22 text-ss-secondary text-montserrat fw-700'>
                    Dose-Response Assessment
                </text>
            </div>

            <div className='py-2 pb-3'>
                <text className='fs-ss-16 text-montserrat text-ss-black fw-600' style={{ letterSpacing:'0.5px'}}>
                    Dose-response assessment involves determining the relationship between the dose of a substance and its toxic effects. This assessment helps to determine the safe levels of exposure to a substance.
                </text>
            </div>

            <div className='py-2'>
                <text className='fs-ss-22 text-ss-secondary text-montserrat fw-700'>
                    Toxicokinetic
                </text>
            </div>

            <div className='py-2 pb-3'>
                <text className='fs-ss-16 text-montserrat text-ss-black fw-600' style={{ letterSpacing:'0.5px'}}>
                    Toxicokinetic involves studying a substance's absorption, distribution, metabolism, and excretion in the body. This assessment helps to determine how a substance affects different body systems.
                </text>
            </div>

            <div className='py-2'>
                <text className='fs-ss-22 text-ss-secondary text-montserrat fw-700'>
                    Risk Assessment
                </text>
            </div>

            <div className='py-2 pb-3'>
                <text className='fs-ss-16 text-montserrat text-ss-black fw-600' style={{ letterSpacing:'0.5px'}}>
                    Risk assessment involves evaluating the potential risks and hazards associated with substance use. This assessment helps to determine the safety and effectiveness of a substance.
                </text>
            </div>
        </div>
    </div>
  )
}

export default ToxicologyTestingProcess